// Janela "sempre no topo" do Chrome (Document Picture-in-Picture).
// Ela fica por cima de TODAS as abas e programas, não só do sistema.
// Só Chrome/Edge 116+; nos outros navegadores o botão nem aparece.

export const pipSuportado = () =>
  typeof window !== "undefined" &&
  "documentPictureInPicture" in window &&
  window.top === window; // não funciona dentro de iframe

// Copia um <style>/<link> da página para a janelinha. Lê as regras do CSSOM
// porque o Material-UI às vezes insere regras sem mudar o texto da tag.
const clonarEstilo = (no, destino) => {
  try {
    if (no.tagName === "LINK") {
      if (no.rel !== "stylesheet") return null;
      const link = destino.createElement("link");
      link.rel = "stylesheet";
      link.href = no.href;
      destino.head.appendChild(link);
      return link;
    }
    if (no.tagName === "STYLE") {
      const estilo = destino.createElement("style");
      let texto = "";
      try {
        texto = Array.from(no.sheet?.cssRules || [])
          .map((r) => r.cssText)
          .join("\n");
      } catch (e) {
        texto = "";
      }
      estilo.textContent = texto || no.textContent;
      destino.head.appendChild(estilo);
      return estilo;
    }
  } catch (e) {
    /* estilo que não deu para copiar: segue sem ele */
  }
  return null;
};

/**
 * Abre a janelinha. PRECISA ser chamada direto no clique do usuário.
 * Devolve a janela (window) ou null se não deu.
 */
export const abrirJanelaPip = async ({ largura = 380, altura = 560, titulo = "Conversa", escuro = false } = {}) => {
  if (!pipSuportado()) return null;
  const pip = await window.documentPictureInPicture.requestWindow({ width: largura, height: altura });
  const doc = pip.document;
  doc.title = titulo;

  // Estilos de agora...
  Array.from(document.head.querySelectorAll('style, link[rel="stylesheet"]')).forEach((n) =>
    clonarEstilo(n, doc)
  );
  // ...e os que o React/Material-UI criarem depois (componentes que abrem na janelinha).
  const observador = new MutationObserver((mudancas) => {
    mudancas.forEach((m) =>
      m.addedNodes.forEach((n) => {
        if (n.tagName === "STYLE" || n.tagName === "LINK") {
          // espera o navegador montar a folha de estilo
          setTimeout(() => clonarEstilo(n, doc), 0);
        }
      })
    );
  });
  observador.observe(document.head, { childList: true });
  pip.addEventListener("pagehide", () => observador.disconnect());

  Object.assign(doc.body.style, {
    margin: "0",
    height: "100vh",
    overflow: "hidden",
    background: escuro ? "#161d1a" : "#ffffff",
    fontFamily: getComputedStyle(document.body).fontFamily,
  });
  if (escuro) doc.documentElement.style.colorScheme = "dark";

  const raiz = doc.createElement("div");
  raiz.id = "pip-raiz";
  Object.assign(raiz.style, { height: "100%", display: "flex", flexDirection: "column" });
  doc.body.appendChild(raiz);
  pip.__raiz = raiz;
  return pip;
};
